<section class="section about" id='about' (keydown)="onKeyDown($event)" tabindex="0">
    <div class="container">
        <div class="section-box">
            <div class="about-title" data-animate="slideInUp" data-animate-duration="1000">
                <h3 class="section-title">
                    <span class='n-section-title'>01.</span> {{"AboutMe.Title" | translate}}
                </h3>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <div class="about-description">
                        <p *ngFor='let text of "AboutMe.Paragraphs" | translate; let i = index'
                           [innerHTML]="text"
                           data-animate="fadeInLeft"
                           [attr.data-animate-delay]="200 + (i * 300)"
                           data-animate-duration="800">
                        </p>
                        <ul class="skills-list" data-animate="fadeInUp" data-animate-delay="800">
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="1000">
                                <span class="underline">Angular (v6+) </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="1100">
                                <span class="underline">JavaScript / TypeScript </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="1200">
                                <span class="underline">React / RxJS </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="1300">
                                <span class="underline">Cells / LitElement </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="1400">
                                <span class="underline">HTML5 / CSS3 / Sass </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="1500">
                                <span class="underline">Java / Microservicios </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="1600">
                                <span class="underline">.NET Core </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="1700">
                                <span class="underline">Oracle / SQL Server / MySQL </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="1800">
                                <span class="underline">Jasmine / Karma / Gherkin </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="1900">
                                <span class="underline">GitHub / Bitbucket / GitLab </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="2000">
                                <span class="underline">Metodologías ágiles / Scrum </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="2100">
                                <span class="underline">Jira </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="2200">
                                <span class="underline">Jenkins / CI-CD </span>
                            </li>
                            <li class="skill-element" data-animate="scaleIn" data-animate-delay="2300">
                                <span class="underline">Firebase </span>
                            </li>
                            
                        </ul>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-4 mt-md-0 text-center"
                     data-animate="morphIn"
                     data-animate-duration="1200"
                     data-animate-delay="600">
                    <div class="about-img-container">
                        <img (click)='onImageClick()'
                             class="rounded about-image clickable"
                             width="100%"
                             loading="lazy"
                             decoding="async"
                             src="assets/images/image-adler.jpeg"
                             alt="José Andrés"
                             title="Click para ver imagen ampliada">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal para imagen ampliada -->
    <div class="image-modal-overlay"
         *ngIf="isImageModalOpen"
         (click)="onModalBackdropClick($event)"
         [@fadeInOut]>
        <div class="image-modal-container">
            <button class="modal-close-btn"
                    (click)="closeImageModal()"
                    aria-label="Cerrar modal">
                <span>&times;</span>
            </button>
            <img class="modal-image"
                 src="assets/images/image-adler.jpeg"
                 alt="José Andrés - Imagen ampliada"
                 [@zoomIn]>
        </div>
    </div>
</section>
